import React, { useState, useEffect, useRef } from 'react';
import API from '../services/api';
import './IdPhotoViewer.css';

/* Şəxsiyyət vəsiqəsi şəkillərinə baxış pəncərəsi.
   Fayllar `GET /admission/file/:name` ilə verilir və bu endpoint auth tələb edir —
   buna görə birbaşa <img src> işləmir, blob kimi yüklənib object URL yaradılır. */
export default function IdPhotoViewer({ files, onClose }) {
  const [idx, setIdx] = useState(0);
  const [urls, setUrls] = useState({});
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState(null);
  const [zoom, setZoom] = useState(false);
  const madeRef = useRef([]);

  const cur = files[idx];
  const curUrl = cur ? urls[cur.name] : null;

  useEffect(() => {
    let dead = false;
    if (!cur) return;
    if (urls[cur.name]) { setLoading(false); setErr(null); return; }
    setLoading(true); setErr(null);
    API.get('/admission/file/' + encodeURIComponent(cur.name), { responseType: 'blob' })
      .then(r => {
        if (dead) return;
        const u = URL.createObjectURL(r.data);
        madeRef.current.push(u);
        setUrls(p => ({ ...p, [cur.name]: u }));
        setLoading(false);
      })
      .catch(e => {
        if (dead) return;
        const s = e.response?.status;
        setErr(s === 404 ? 'Fayl serverdə tapılmadı'
             : s === 403 ? 'Bu sənədə baxmaq icazəniz yoxdur'
             : 'Fayl açıla bilmədi');
        setLoading(false);
      });
    return () => { dead = true; };
  }, [cur]); // eslint-disable-line react-hooks/exhaustive-deps

  /* Object URL-lər pəncərə bağlananda azad edilir */
  useEffect(() => () => madeRef.current.forEach(u => URL.revokeObjectURL(u)), []);

  useEffect(() => {
    const h = e => {
      if (e.key === 'Escape') onClose();
      else if (e.key === 'ArrowRight') { setZoom(false); setIdx(i => Math.min(i + 1, files.length - 1)); }
      else if (e.key === 'ArrowLeft') { setZoom(false); setIdx(i => Math.max(i - 1, 0)); }
    };
    window.addEventListener('keydown', h);
    return () => window.removeEventListener('keydown', h);
  }, [files.length, onClose]);

  if (!cur) return null;
  const ext = (cur.name.split('.').pop() || 'jpg').toLowerCase();

  return (
    <div className="idp-overlay" onClick={onClose}>
      <div className="idp-box" onClick={e => e.stopPropagation()}>
        <div className="idp-head">
          <div className="idp-title">
            <span className="idp-doc-ico" aria-hidden="true">🪪</span>
            {cur.label}
            {files.length > 1 && <span className="idp-count">{idx + 1} / {files.length}</span>}
          </div>
          <div className="idp-head-act">
            {curUrl && (
              <a className="idp-btn" href={curUrl} download={(cur.download || 'sened') + '.' + ext}>Yüklə</a>
            )}
            <button className="idp-btn idp-close" onClick={onClose} title="Bağla (Esc)">✕</button>
          </div>
        </div>

        <div className={'idp-body' + (zoom ? ' zoomed' : '')}>
          {loading && <div className="idp-state">Yüklənir…</div>}
          {err && <div className="idp-state idp-err">{err}</div>}
          {!loading && !err && curUrl && (
            <img src={curUrl} alt={cur.label}
              className={zoom ? 'zoomed' : ''}
              onClick={() => setZoom(z => !z)}
              title={zoom ? 'Kiçiltmək üçün klikləyin' : 'Böyütmək üçün klikləyin'} />
          )}
        </div>

        {files.length > 1 && (
          <div className="idp-foot">
            {files.map((f, i) => (
              <button key={f.name}
                className={'idp-tab' + (i === idx ? ' active' : '')}
                onClick={() => { setZoom(false); setIdx(i); }}>{f.label}</button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
